import { Star } from 'lucide-react';

const REVIEWS = [
  { text: 'A minha pele é muito sensível, tenho dificuldade em encontrar produtos que me fazem bem, e estes produtos são fantásticos.', name: 'Amanda Ferreira', product: 'Kit Regeneração Intensiva' },
  { text: 'Se você tem a pele seca pode comprar sem medo. Nunca vi um produto que trata tão bem pele ressecada e tem o toque seco, então não fica grudando.', name: 'Thay Mondoni', product: 'Kit Regeneração Intensiva' },
  { text: 'Experimentei o tamanho menor e adorei. Dessa vez comprei o tamanho maior, porque compensa mais. Uso após o banho e ele fica na pele por horas.', name: 'Zélia M. Oliveira', product: 'Hidratante Corporal 1kg' },
  { text: 'Comprei esse kit para a minha mãe. Ela adorou, principalmente porque não gosta de cheiros artificiais.', name: 'Alexandre Califani', product: 'Kit Regeneração Intensiva' },
  { text: 'Vivo descalça e meus pés eram muito ásperos. Comecei a hidratar toda noite e meus pés são outros agora.', name: 'Bárbara A. Novais', product: 'Hidratante para os Pés' },
  { text: 'Eu que uso luvas todos os dias, minhas mãos ficam macias com o creme.', name: 'Raquel Petta', product: 'Hidratante para as Mãos' },
];

export const FeaturedReviewsV2 = () => (
  <div className="mt-14 border-t border-v2-bg/15 pt-10">
    <p className="text-base text-v2-bg/85">Avaliações reais de clientes, publicadas pela Konfidency.</p>
    <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
      {REVIEWS.map((review) => (
        <article key={review.name} className="flex min-h-[230px] flex-col rounded-xl border border-v2-bg/15 bg-v2-bg p-5 text-v2-ink">
          <div className="flex" aria-label="5 de 5 estrelas">
            {[1, 2, 3, 4, 5].map((value) => <Star key={value} className="h-4 w-4 fill-brand-amber text-brand-amber" />)}
          </div>
          <blockquote className="mt-4 flex-1 text-base leading-relaxed">“{review.text}”</blockquote>
          <footer className="mt-5 border-t border-v2-ink/10 pt-4">
            <p className="font-semibold">{review.name}</p>
            <p className="text-sm text-v2-muted">{review.product}</p>
          </footer>
        </article>
      ))}
    </div>
  </div>
);